module.exports = __webpack_public_path__ + "static/lets-ae50f21639d77060649d51c0302b394b.png";